import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {permissions, profilePicSrc, INITIALS_SIZE, DATE_PICKER_STYLE} from '../../constants';
import TdLink from '../../components/td_link';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import Util from '../../forecast-app/shared/util/util';
import UpdatePersonMutation from '../../mutations/update_person_mutation.modern';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import ActionsMenu from '../../forecast-app/shared/components/action-menu/actions_menu';
import {showModal, MODAL_TYPE} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import HarvestIcon from '../../images/integrations/harvest-logo.png';
import TimeLogIcon from '../../images/integrations/timelog-logo.png';
import GitLabIcon from '../../images/integrations/gitlab.png';
import JiraIcon from '../../images/integrations/jira-logo.png';
import AsanaIcon from '../../images/integrations/asana-logo.png';
import Unit4Icon from '../../images/integrations/unit4-small-logo.svg';
import {MSTeamsIcon, BambooHRIcon, GithubIcon, EconomicIcon, AdoIcon} from 'web-components';
import PersonInitials from '../../forecast-app/shared/components/person/person_initials';
import UpdateCompanyMutation from '../../mutations/update_company_mutation.modern';
import DatePicker from '../../forecast-app/shared/components/date-picker/date_picker_v3';
import {getProfileName, personHasPermission, personIsVirtualUser} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';
import {hasFeatureFlag} from '../../forecast-app/shared/util/FeatureUtil';

class settingsPeoplePerson extends Component {
	constructor(props) {
		super(props);

		const workingHours = [
			this.props.person.sunday / 60,
			this.props.person.monday / 60,
			this.props.person.tuesday / 60,
			this.props.person.wednesday / 60,
			this.props.person.thursday / 60,
			this.props.person.friday / 60,
			this.props.person.saturday / 60,
		];

		// If it non-us, remove sunday from the list and add it after saturday
		if (this.props.viewer.language !== 'ENGLISH_US') {
			const sunday = workingHours.shift();
			workingHours.push(sunday);
		}

		const costPeriod = this.props.person.costPeriods.edges.length === 1 ? this.props.person.costPeriods.edges[0] : null;

		this.state = {
			cost: costPeriod ? costPeriod.node.cost : null,
			costPeriod,
			workingHours,
		};
	}

	componentDidUpdate(prevProps) {
		// Manually update state when costPeriod is updated
		if (prevProps.person.costPeriods.edges.length === 1 && this.props.person.costPeriods.edges.length === 1) {
			const newCostPeriod = this.props.person.costPeriods.edges[0];
			if (prevProps.person.costPeriods.edges[0].node.cost !== newCostPeriod.node.cost) {
				this.setState({cost: newCostPeriod.node.cost, costPeriod: newCostPeriod});
			}
		}
	}

	onRoleChange(role) {
		const {person} = this.props;
		if (!person || !role) return;

		// Prevent if the role is the same
		if (person.role && person.role.id === role.value) return;

		Util.CommitMutation(
			UpdatePersonMutation,
			{
				id: person.id,
				roleId: role.value,
			},
			() => this.showChangesSavedToast(2000),
			true,
			false
		);
	}

	onDepartmentChange(department) {
		const {person} = this.props;
		if (!person || !department) return;

		// Prevent if the role is the same
		if (person.department && person.department.id === department.value) return;

		Util.CommitMutation(
			UpdatePersonMutation,
			{
				id: person.id,
				departmentId: department.value,
			},
			() => this.showChangesSavedToast(2000),
			true,
			false
		);
	}

	onProfileChange(profile) {
		const {person} = this.props;
		const {company} = this.props.viewer;
		const userSeats = company.subscription && company.subscription.seats;
		const virtualSeats = company.subscription && company.subscription.virtualSeats;

		if (!person || !profile) return;

		// Prevent if the permission is the same
		if (person.profileId && person.profileId === profile.value) return;

		// If we are changing a user from 'Virtual' to another permission, we need a confirmation modal to change the permission
		if (personIsVirtualUser(person) && this.props.isCompanyOverUserCap && this.props.isCompanyOverUserCap()) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: userSeats,
				warningMessageId: 'team_modal.seats_warning_permission_change_failed',
			});
			// If we are changing a user to a 'Virtual' one, we need a confirmation modal to change the permission
		} else if (
			personIsVirtualUser(profile.profile) &&
			this.props.isCompanyOverVirtualUserCap &&
			this.props.isCompanyOverVirtualUserCap()
		) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: virtualSeats,
				seatType: 'virtual ',
				warningMessageId: 'team_modal.seats_warning_permission_change_failed',
			});
			// If the user is changed from virtual, but has no email, prompt for an email
		} else if (personIsVirtualUser(person) && !person.email) {
			showModal({
				type: MODAL_TYPE.ADD_EMAIL,
				personId: person.id,
				callback: this.runProfileMutation.bind(this, person, profile),
			});
		} else {
			this.runProfileMutation(person, profile);
		}
	}

	runProfileMutation(person, profile) {
		const data = {
			id: person.id,
			profileId: profile.value,
		};
		if (!person.invited && personIsVirtualUser(person) && !personIsVirtualUser(profile.profile)) {
			data.invited = true;
		}
		const onSuccess = () => this.showChangesSavedToast(2000);

		if (personHasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS, profile.profile)) {
			showModal({
				type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
				mutation: UpdatePersonMutation,
				mutationName: 'updatePerson',
				data,
				onSuccess,
			});
		} else {
			Util.CommitMutation(UpdatePersonMutation, data, onSuccess);
		}
	}

	// Deprecated with release of profiles
	onPermissionChange(permission) {
		const {person} = this.props;
		const {company} = this.props.viewer;
		const userSeats = company.subscription && company.subscription.seats;
		const virtualSeats = company.subscription && company.subscription.virtualSeats;

		if (!person || !permission) return;

		// Prevent if the permission is the same
		if (person.userType && person.userType === permission.value) return;

		// If we are changing a user from 'Virtual' to another permission, we need a confirmation modal to change the permission
		if (person.userType === 'NO_LOGIN' && this.props.isCompanyOverUserCap && this.props.isCompanyOverUserCap()) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: userSeats,
				warningMessageId: 'team_modal.seats_warning_permission_change_failed',
			});
			// If we are changing a user to a 'Virtual' one, we need a confirmation modal to change the permission
		} else if (
			permission.value === 'NO_LOGIN' &&
			this.props.isCompanyOverVirtualUserCap &&
			this.props.isCompanyOverVirtualUserCap()
		) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: virtualSeats,
				seatType: 'virtual ',
				warningMessageId: 'team_modal.seats_warning_permission_change_failed',
			});
			// If the user is changed from virtual, but has no email, prompt for an email
		} else if (person.userType === 'NO_LOGIN' && !person.email) {
			showModal({
				type: MODAL_TYPE.ADD_EMAIL,
				personId: person.id,
				callback: this.runPermissionMutation.bind(this, person, permission),
			});
		} else {
			this.runPermissionMutation(person, permission);
		}
	}

	runPermissionMutation(person, permission) {
		const data = {
			id: person.id,
			userType: permission.value,
			//viewerId: this.props.viewer.id
		};
		if (!person.invited && person.userType === 'NO_LOGIN' && permission.value !== 'NO_LOGIN') {
			data.invited = true;
		}
		const onSuccess = () => this.showChangesSavedToast(2000);

		if (permission.value === 'ADMIN') {
			showModal({
				type: MODAL_TYPE.CONFIRM_PASSWORD_MODAL,
				mutation: UpdatePersonMutation,
				mutationName: 'updatePerson',
				data,
				onSuccess,
			});
		} else {
			Util.CommitMutation(UpdatePersonMutation, data, onSuccess);
		}
	}

	handleStartDateChange(person, value) {
		this.updateStartDate(person, value.format('YYYY-MM-DD'));
	}
	handleEndDateChange(person, value) {
		this.updateEndDate(person, value.format('YYYY-MM-DD'));
	}
	handleClearStartDate(person) {
		this.updateStartDate(person, null);
	}
	handleClearEndDate(person) {
		this.updateEndDate(person, null);
	}

	updateStartDate(person, startDate) {
		const onSuccess = () => {
			this.showChangesSavedToast(2000);
		};
		Util.CommitMutation(
			UpdatePersonMutation,
			{
				id: person.id,
				startDate: startDate,
			},
			onSuccess
		);
	}
	updateEndDate(person, endDate) {
		const onSuccess = () => {
			this.showChangesSavedToast(2000);
		};
		Util.CommitMutation(
			UpdatePersonMutation,
			{
				id: person.id,
				endDate: endDate,
			},
			onSuccess
		);
	}

	showChangesSavedToast(duration) {
		createToast({duration, message: this.props.intl.formatMessage({id: 'common.changes_saved'})});
	}

	getLinkPath(person) {
		if (person.isViewer) {
			return '/my-profile/profile';
		} else {
			return '/settings/team/view-user/' + person.id;
		}
	}

	showInternalCostPeriodsModal() {
		showModal({
			type: MODAL_TYPE.COST_PERIODS,
			personId: this.props.person.id,
		});
	}

	showPersonSkillsModal() {
		showModal({
			type: MODAL_TYPE.PERSON_SKILLS,
			personId: this.props.person.id,
		});
	}

	getViewer() {
		return this.props.viewer;
	}

	activatePerson() {
		const {person} = this.props;
		const {company} = this.props.viewer;
		const {formatMessage} = this.props.intl;
		const userSeats = company.subscription && company.subscription.seats;
		const virtualSeats = company.subscription && company.subscription.virtualSeats;

		const onSuccess = () => {
			const message = 'team-member.has-been-enabled';
			createToast({duration: 5000, message: formatMessage({id: message})});
		};
		const mutationObject = {
			id: person.id,
			active: true,
		};

		// If we are changing a user from 'Virtual' to another permission, we need a confirmation modal to change the permission
		if (!personIsVirtualUser(person) && this.props.isCompanyOverUserCap && this.props.isCompanyOverUserCap()) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: userSeats,
				warningMessageId: 'team_modal.seats_warning_activation_failed',
			});
			// If we are changing a user to a 'Virtual' one, we need a confirmation modal to change the permission
		} else if (
			personIsVirtualUser(person) &&
			this.props.isCompanyOverVirtualUserCap &&
			this.props.isCompanyOverVirtualUserCap()
		) {
			showModal({
				type: MODAL_TYPE.NO_AVAILABLE_SEATS,
				seats: virtualSeats,
				seatType: 'virtual ',
				warningMessageId: 'team_modal.seats_warning_activation_failed',
			});
		} else {
			Util.CommitMutation(UpdatePersonMutation, mutationObject, onSuccess, true, false);
		}
	}

	deactivatePerson() {
		const {person} = this.props;
		const contactPerson = this.props.viewer.company.contactPerson;

		const onSuccess = () => {
			const message = 'team-member.has-been-deleted';
			createToast({duration: 5000, message: this.props.intl.formatMessage({id: message})});
		};
		const deactivatePerson = () => {
			const mutationObject = {
				id: person.id,
				active: false,
				//viewerId: this.props.viewer.id
			};

			Util.CommitMutation(UpdatePersonMutation, mutationObject, onSuccess, true, false);
		};

		const callbackPositive = selected => {
			Util.CommitMutation(
				UpdateCompanyMutation,
				{
					id: this.props.viewer.company.id,
					contactPersonId: selected.value,
				},
				() => deactivatePerson()
			);
		};

		const personOptions = this.props.viewer.company.allPersons.edges
			.filter(p => p.node.email && p.node.id !== person.id)
			.map(p => {
				return {
					value: p.node.id,
					label: p.node.fullName,
					profilePictureId: p.node.profilePictureId,
					firstName: p.node.firstName,
					lastName: p.node.lastName,
				};
			})
			.sort((a, b) => a.label - b.label);

		if (contactPerson && contactPerson.id === person.id) {
			showModal({
				type: MODAL_TYPE.SELECT_V2,
				title: 'Select new contact person',
				subTitle: 'You are deactivating the current company contact. Select a new contact person to proceed.',
				defaultCallback: callbackPositive,
				options: personOptions,
				label: 'Contact Person',
				multi: false,
				personSelect: true,
			});
		} else {
			deactivatePerson();
		}
	}

	getActionsMenuOptions() {
		const {person, viewer} = this.props;
		const {formatMessage} = this.props.intl;

		const activeOptions = [
			{text: formatMessage({id: 'settings_people.go_to_profile'}), linkPath: this.getLinkPath(this.props.person)},
		];

		if (this.props.hasFinancial) {
			activeOptions.push({
				text: formatMessage({id: 'settings_people.internal_cost_periods'}),
				onClick: this.showInternalCostPeriodsModal.bind(this),
			});
		}

		// Don't add the deactivate option for the viewer
		if (person.id !== viewer.actualPersonId) {
			activeOptions.push({text: formatMessage({id: 'common.deactivate'}), onClick: this.deactivatePerson.bind(this)});
		}

		const inactiveOptions = [{text: formatMessage({id: 'common.activate'}), onClick: this.activatePerson.bind(this)}];

		return this.props.deactivated ? inactiveOptions : activeOptions;
	}

	render() {
		const {person, viewer} = this.props;

		const currencySymbol = Util.GetCurrencySymbol(viewer.company.currency);
		const currentCostPeriod = Util.getCurrentCostPeriod(person.costPeriods.edges);
		const filteredPermissions = permissions.filter(p => p.value !== 'CLIENT' && p.value !== 'SHARE_PROJECT_TIMELINE');
		const currPerm = filteredPermissions.find(p => p.value === person.userType);

		const createdByPerson = viewer.company.allPersons.edges.find(p => p.node.id === person.createdBy);
		const createdAtMoment = Moment(person.createdAt);

		return (
			<tr
				data-cy="row-member"
				key={person.id}
				className="row-member"
				data-userpilot={this.props.firstUser ? 'person-first' : null}
			>
				<TdLink
					cy="name-width"
					className="person person-width"
					path={this.getLinkPath(person)}
					content={
						<div className="wrapper" data-cy="name-width">
							<div className="image-container">
								<div className="profile-picture">
									{person.profilePictureId ? (
										<img
											crossOrigin="use-credentials"
											src={profilePicSrc(person.profilePictureId)}
											width="36"
											height="36"
											alt=""
										/>
									) : (
										<PersonInitials initials={person.initials} size={INITIALS_SIZE.SMALL} />
									)}
								</div>
							</div>
							<div className="name-tile">
								<h3 className="name">
									{(person.firstName || '') + (person.lastName !== null ? ' ' + person.lastName : '')}
								</h3>
							</div>
						</div>
					}
				/>

				<td className="role-width">
					<Dropdown
						inputCy={'role-dropdown'}
						focusOnClick={true}
						optionClickEvent={true}
						onChange={this.onRoleChange.bind(this)}
						options={this.props.roles.map(role => {
							return {label: role.node.name, value: role.node.id};
						})}
						value={person.role ? person.role.id : ''}
						hideLabel={true}
						disabled={false}
						listDataCy="role"
					/>
				</td>

				{hasFeatureFlag('skills') && (
					<td
						style={{textTransform: 'lowercase'}}
						onClick={this.showPersonSkillsModal.bind(this)}
						className={'person-skill-link '}
					>
						{this.props.person.skills.edges.length} {this.props.intl.formatMessage({id: 'common.skills'})}
					</td>
				)}

				{Util.hasDepartments(viewer.company.modules) ? (
					<td className="department-width">
						<Dropdown
							inputCy={'department-dropdown'}
							focusOnClick={true}
							optionClickEvent={true}
							onChange={this.onDepartmentChange.bind(this)}
							options={this.props.departments.map(department => {
								return {label: department.node.name, value: department.node.id};
							})}
							value={person.department ? person.department.id : ''}
							hideLabel={true}
							disabled={false}
							listDataCy="department"
						/>
					</td>
				) : null}

				<td className="permissions-width">
					{this.props.newPermissions ? (
						<Dropdown
							placeholder={getProfileName(
								viewer.company.profiles.edges.map(profile => profile.node),
								person.profileId
							)}
							focusOnClick={true}
							optionClickEvent={true}
							onChange={this.onProfileChange.bind(this)}
							options={this.props.profiles}
							value={person.profileId}
							hideLabel={true}
							disabled={viewer.actualPersonId === person.id}
						/>
					) : (
						<Dropdown
							focusOnClick={true}
							optionClickEvent={true}
							onChange={this.onPermissionChange.bind(this)}
							options={filteredPermissions}
							value={currPerm ? currPerm.value : null}
							hideLabel={true}
							disabled={viewer.actualPersonId === person.id}
						/>
					)}
				</td>

				{!this.props.hasFinancial ? null : (
					<td onClick={this.showInternalCostPeriodsModal.bind(this)} className={'cost cost-modal-link'}>
						{Util.getFormattedNumberWithCurrency(
							currencySymbol,
							currentCostPeriod ? currentCostPeriod.node.cost : 0,
							this.props.intl
						)}
					</td>
				)}

				<td className="date-width">
					<DatePicker
						startDate={person.startDate ? Moment(person.startDate) : null}
						handleDateRangeChange={this.handleStartDateChange.bind(this, person)}
						clearBothDates={this.handleClearStartDate.bind(this, person)}
						datePickerStyle={DATE_PICKER_STYLE.SLIM}
						isSingleDatePicker
						clearable
						endDateLimite={person.endDate ? Moment(person.endDate).add(1, 'days') : null}
						hideLimitMessage
						startDateEmptyText="-"
					/>
				</td>
				<td className="date-width">
					<DatePicker
						startDate={person.endDate ? Moment(person.endDate) : null}
						handleDateRangeChange={this.handleEndDateChange.bind(this, person)}
						clearBothDates={this.handleClearEndDate.bind(this, person)}
						datePickerStyle={DATE_PICKER_STYLE.SLIM}
						isSingleDatePicker
						clearable
						startDateLimite={person.startDate ? Moment(person.startDate) : null}
						hideLimitMessage
						startDateEmptyText="-"
					/>
				</td>

				{this.props.theEyeOptions && this.props.theEyeOptions.find(option => option.name === 'created-at').checked ? (
					<td className="created-at-cell" title={createdAtMoment.format('LLL')}>
						{createdAtMoment.format('LL')}
					</td>
				) : null}
				{this.props.theEyeOptions && this.props.theEyeOptions.find(option => option.name === 'created-by').checked ? (
					<td className="created-by-cell">{createdByPerson ? createdByPerson.node.fullName : null}</td>
				) : null}
				{this.props.integrationsEnabled ? (
					<td className="integrations-cell">
						{viewer.company.harvestEnabled && person.harvestUser ? (
							<div className="harvest-icon">
								<img
									width={20}
									height={20}
									src={HarvestIcon}
									alt="Harvest"
									title="Harvest"
									onClick={e => {
										e.stopPropagation();
										window.open(this.getLinkPath(person), '_self');
									}}
								/>
							</div>
						) : (
							''
						)}
						{person.economicUser ? <EconomicIcon /> : ''}
						{person.timeLogUser && person.timeLogUser.integrationUserId ? (
							<img width={20} height={20} src={TimeLogIcon} alt="TimeLog" title="TimeLog" />
						) : (
							''
						)}
						{person.gitlabUser && person.gitlabUser.integrationUserId ? (
							<img width={20} height={20} src={GitLabIcon} alt="GitLab" title="GitLab" />
						) : (
							''
						)}
						{person.gitlabServerUser && person.gitlabServerUser.integrationUserId ? (
							<img width={20} height={20} src={GitLabIcon} alt="GitLab Server" title="GitLab Server" />
						) : (
							''
						)}
						{person.githubUser && person.githubUser.integrationUserId ? <GithubIcon /> : ''}
						{person.jiraServerUser ? (
							<img width={20} height={20} src={JiraIcon} alt="Jira Server" title="Jira Server" />
						) : (
							''
						)}
						{person.jiraCloudUser ? (
							<img width={20} height={20} src={JiraIcon} alt="Jira Cloud" title="Jira Cloud" />
						) : (
							''
						)}
						{person.asanaUser ? <img width={20} height={20} src={AsanaIcon} alt="Asana" title="Asana" /> : ''}
						{person.vstsUser ? <AdoIcon /> : ''}
						{person.unit4User ? <img width={20} height={20} src={Unit4Icon} alt="Unit4" title="Unit4" /> : ''}
						{person.msTeamsId ? <MSTeamsIcon /> : ''}
						{person.bambooHRId ? <BambooHRIcon /> : ''}
					</td>
				) : null}
				<td className="person-action-menu controls-width">
					<ActionsMenu
						disabled={false}
						customWidth={20}
						whiteInner={true}
						isWhite={false}
						options={this.getActionsMenuOptions()}
						leftOffset={-10}
						userpilot={this.props.firstUser ? 'person-actions-menu-first' : null}
					/>
				</td>
			</tr>
		);
	}
}

settingsPeoplePerson.propTypes = {
	isCompanyOverUserCap: PropTypes.func.isRequired,
	isCompanyOverVirtualUserCap: PropTypes.func.isRequired,
	key: PropTypes.number,
	person: PropTypes.object.isRequired,
	viewer: PropTypes.object,
	integrationsEnabled: PropTypes.bool.isRequired,
};

export default injectIntl(settingsPeoplePerson);
